import { Button, Image, Popover, Select, Tabs, Upload, Input, message } from "antd"
import { forwardRef, useCallback, useEffect, useImperativeHandle, useMemo, useRef, useState } from "react"
import API, { commonApiInvoker } from "@api/api"
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import ImageItem from "../ImageItem"
import styles from "./index.module.scss"
import * as _ from "underscore";
import Utils from "@utils/utils"
import { IMAGE_TYPE, BATCH_IMAGES_TYPE, RESOURCE_TYPE, RESOURCE_PARAMS } from "@utils/CONST"
import PSAIModal from "@PSAIComponents/PSAIModal";
import CustomModelForm from "@view/page/selfModelFakeLeft/CustomModelForm";
import ModelFilterSelection from "@view/page/selfModelFakeLeft/ModelFilterSelection";
import ModelFilterSelectionNew from "@view/page/selfModelFakeLeft/ModelFilterSelection_new";
import Iconfont from '@utils/Iconfont';
import { CloseOutlined } from '@ant-design/icons';
import SelectionFilterSearch from '@view/page_v3/LeftComp/components/SelectionFilterSearch'
import UploadRequirements from "@view/page_v3/LeftComp/components/UploadRequirements"
import eventBus from '@utils/eventBus'
const fallback = require('@assets/images/fallback.png')

const getResourceData = (projectType) => {
    return projectType == BATCH_IMAGES_TYPE.TRYON_BATCH ||
        projectType == BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ? {
        func: "model",
        type: "tryOn",
    } : projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ? {
        func: "model",
        type: "person",
    } : projectType == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ? {
        func: "model",
        type: "background",
    } : projectType == BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? {
        func: "commodity",
        type: "stacking",
    } : {}
}

const ImgToVideoContent = (props) => {
    const { type, setPrompt, resourceType } = props
    const [force, updateForce] = useState()
    const [promptList, setPromptList] = useState([])
    const [promptOpen, setPromptOpen] = useState(false)
    const [title, setTitle] = useState('')
    const [desc, setDesc] = useState('')
    const [editId, setEditId] = useState(null)

    useEffect(() => {
        if (resourceType != RESOURCE_TYPE.IMAGE_TO_VIDEO) return
        if (!RESOURCE_PARAMS[resourceType]) return
        commonApiInvoker(API.getCustomResources2({ ...RESOURCE_PARAMS[resourceType], pageIndex: 1, pageSize: 50000 })).then(res => {
            setPromptList(res?.items || [])
        })
    }, [force, resourceType])

    useEffect(() => {
        if (resourceType != RESOURCE_TYPE.IMAGE_TO_VIDEO) return
        const handler = () => updateForce({})
        eventBus.on('updateImgToVideoPrompt', handler)
        return () => eventBus.off('updateImgToVideoPrompt', handler)
    }, [resourceType])

    const promptGroups = useMemo(() => ([
        { key: 'subject', title: '主体', options: ['女人', '男人', '男孩', '女孩'] },
        { key: 'action', title: '动作', options: ['服饰展示', '往前行走', '右手抬起', '模特台步', '身体自然左右晃动', '手自然插入口袋'] },
        { key: 'camera', title: '运镜', options: ["镜头固定", "镜头从左往右", "镜头从右往左", "镜头推进", "镜头拉远", "镜头上摇", "镜头下摇", "环绕运镜", "原地旋转展示", "左旋推进", "右旋推进", "推进上移", "推进拉远"] }
    ]), [])

    const handleRemove = (record) => {
        PSAIModal.confirm({
            title: `确定删除这段提示词吗？`,
            onOk() {
                return commonApiInvoker(API.removeCustomMaterial({ id: record.id })).then(() => {
                    message.success('删除成功')
                    updateForce({})
                })
            }
        })
    }

    const handleAddPrompt = async () => {
        if (!desc) return message.error('请输入描述')
        const res = await API.saveCustomMaterialv2({
            ...(editId ? { id: editId } : {}),
            func: IMAGE_TYPE.IMAGE_TO_VIDEO,
            type: 'image2VideoPrompt',
            image: desc?.trim(),
            attr: { title: title?.trim() || '未命名标题' }
        })
        if (res?.code != 0) throw new Error(res?.message)
        setPromptOpen(false)
        setEditId(null)
        updateForce({})
    }

    return <div className={styles.ImgToVideoContent}>
        {
            type == 'prompt' ? <div className={`${styles.ImgToVideoContent_prompt} _none_scrollbar`}>
                {promptGroups.map(group => <div key={group.key} className={styles.ImgToVideoContent_promptGroup}>
                    <div className={styles.ImgToVideoContent_promptTitle}>{group.title}</div>
                    <div className={styles.ImgToVideoContent_promptOptions}>
                        {group.options.map(opt => <Button key={`${group.key}_${opt}`} className={`${styles.ImgToVideoContent_promptBtn}`} onClick={() => setPrompt(prev => (prev ? `${prev}${opt}，` : `${opt}，`))}>{opt}</Button>)}
                    </div>
                </div>)}
            </div> : type == 'mine' ? <div className={`${styles.ImgToVideoContent_mine} _none_scrollbar`}>
                <Button className={styles.ImgToVideoContent_mineAddBtn} onClick={() => { setEditId(null); setTitle(''); setDesc(''); setPromptOpen(true) }}><Iconfont type="icon-general_dd" className={styles.Icon} /> 新增提示词</Button>
                {promptList?.map(item => <div key={item.key} className={styles.ImgToVideoContent_mineItem} onClick={() => setPrompt(item.imageUrl)}>
                    <div className={styles.ImgToVideoContent_mineHeader}>
                        <div className={styles.ImgToVideoContent_mineActions}>
                            <Iconfont type="icon-editOutlined" className={styles.Icon} onClick={(e) => { e.stopPropagation(); setEditId(item.id); setTitle(item.attr?.title || ''); setDesc(item.imageUrl || ''); setPromptOpen(true) }} />
                            <Iconfont type="icon-DeleteOutlined" className={styles.Icon} onClick={(e) => { e.stopPropagation(); handleRemove(item) }} />
                        </div>
                        <div className={styles.ImgToVideoContent_mineTitle}>{item.attr?.title}</div>
                    </div>
                    <div className={styles.ImgToVideoContent_mineDesc}>{item.imageUrl}</div>
                </div>)}
            </div> : null
        }
        <PSAIModal title="新增提示词" open={promptOpen} maskClosable={false} maxWidth={528} onCancel={() => setPromptOpen(false)} onOk={handleAddPrompt} getContainer={"body"} zIndex={10000}>
            <div className={styles.ImgToVideoContent_modalForm}>
                <div className={styles.ImgToVideoContent_modalItem}>
                    <Input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="请输入描述标题（选填）" className={styles.ImgToVideoContent_modalInput} />
                </div>
                <div className={styles.ImgToVideoContent_modalItem}>
                    <div className={styles.ImgToVideoContent_modalLabel}>描述</div>
                    <Input.TextArea value={desc} onChange={(e) => setDesc(e.target.value)} placeholder="请输入描述" maxLength={800} autoSize={{ minRows: 8, maxRows: 8 }} className={styles.ImgToVideoContent_modalTextArea} />
                </div>
            </div>
        </PSAIModal>
    </div>
}

const CustomPoseList = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        refresh: () => updateForce({}),
        uploadFiles: (fileList) => doUploadFiles(fileList),
        onFavor: (record, favor) => {
            setList(pre => {
                const temp = [...pre]
                const item = temp.find(item => item.id == record.id)
                if (!item) return temp
                item.isFavorite = favor
                return [...temp]
            })
        }
    }))
    const [loading, setLoading] = useState(false)
    const [list, setList] = useState([])
    const [force, updateForce] = useState()
    const isLoop = useRef()
    const isMounted = useRef(true)
    const pendingAutoSelectIdRef = useRef(null) // 暂存自定义模特、用于自动选中

    useEffect(() => {
        return () => {
            isMounted.current = false
        }
    }, [])

    const loopFunc = () => {
        updateForce({})
        if (isLoop.current && isMounted.current) {
            setTimeout(() => {
                loopFunc()
            }, 2000)
        }
    }

    useEffect(() => {
        if (props.activeKey != "custom") return
        props.onChange(list.filter(item => ("maskStatus" in item.attr ? item.attr?.maskStatus == "succeeded" : true)))
    }, [props.activeKey, list])

    useEffect(() => {
        const notSucc = !!list.find(item => ("maskStatus" in item.attr ? item.attr?.maskStatus != "succeeded" : false))
        if (notSucc) {
            if (!isLoop.current) {
                isLoop.current = true
                // loopFunc()
            }
        } else {
            if (isLoop.current) {
                isLoop.current = false
            }
        }
    }, [list])

    const totalRef = useRef(1)
    useEffect(() => {
        const data = getResourceData(props.projectType)
        commonApiInvoker(API.getCustomResources2({
            ...data,
            pageIndex: 1,
            pageSize: totalRef.current
        })).then(res => {
            const total = res.total
            if (!total) return setList([])
            if (total != totalRef.current) {
                totalRef.current = total
                commonApiInvoker(API.getCustomResources2({
                    ...data,
                    pageIndex: 1,
                    pageSize: totalRef.current
                })).then(res => {
                    const list = (res?.items ?? []).filter(item => item.name != "00_default_style")
                    const nextList = list.map(item => ({
                        ...item,
                        isFavorite: item.attr.isFavorite,
                        attr: {
                            ...item.attr,
                            custom: true
                        }
                    }))
                    // 自动选中自定义模特
                    if (pendingAutoSelectIdRef.current != null) {
                        const record = nextList.find(item => item?.id == pendingAutoSelectIdRef.current)
                        if (record) {
                            pendingAutoSelectIdRef.current = null
                            props.onClick?.(record)
                        }
                    }
                    setList(nextList)
                })
            } else {
                const list = (res?.items ?? []).filter(item => item.name != "00_default_style")
                const nextList = list.map(item => ({
                    ...item,
                    isFavorite: item.attr.isFavorite,
                    attr: {
                        ...item.attr,
                        custom: true
                    }
                }))
                // 自动选中自定义模特
                if (pendingAutoSelectIdRef.current != null) {
                    const record = nextList.find(item => item?.id == pendingAutoSelectIdRef.current)
                    if (record) {
                        pendingAutoSelectIdRef.current = null
                        props.onClick?.(record)
                    }
                }
                setList(nextList)
            }
        })
    }, [force])

    const [totalNum, setTotalNum] = useState(0)
    const [succNum, setSuccNum] = useState(0)
    const uploadFileWithAntispamId = (file) => {
        return Utils.checkImageIslegal(file, 1).then(res => {
            if (!res) return false
            if (!res.isLegal) {
                PSAIModal.confirm({
                    content: '经检测，您上传的内容涉嫌违规，已进行屏蔽处理，人工审核会对图片进行复核。',
                    okText: '重新上传',
                    cancelText: '取消',
                    onOk() {
                        Utils.openFile().then((res) => {
                            if (res) beforeUpload(res)
                        })
                    },
                    onCancel() { },
                })
                return false
            } else {
                const { imageAntispamId, data } = res
                return {
                    url: data,
                    imageAntispamId
                }
            }
        }).catch((err) => {
            message.error(err.message)
        })
    }
    function removeExtension(filename) {
        if (filename === '.' || filename === '..') return filename;

        const lastDot = filename.lastIndexOf('.')
        if (lastDot === -1 || lastDot === 0) return filename;

        return filename.substring(0, lastDot);
    }
    async function doUploadFiles(fileList) {
        if (!fileList?.length) return []
        if (fileList.length > 30) {
            message.warning("每次最多上传30张图")
            fileList = fileList.slice(0, 30)
        }
        const selectedKeys = []
        setSuccNum(0)
        setTotalNum(fileList.length)
        setLoading(true)
        for (let file of fileList) {
            const name = removeExtension(file.name)
            let isNromal = false
            if (props.projectType == BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH) {
                isNromal = await Utils.validateImageFilePNG(file)
            } else {
                isNromal = await Utils.validateImageFile(file)
            }
            if (!isNromal) continue
            const resizeRes = await Utils.resizeImageFileMaxByAliyunBy(file, 4096)
            if (!resizeRes || !resizeRes.success) { message.warning(resizeRes?.message); continue; }
            file = resizeRes.file
            try {
                const res = await uploadFileWithAntispamId(file)
                if (!res) continue
                const { url, imageAntispamId } = res
                if (props.projectType == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH) {
                    const res2 = await API.saveCustomMaterialv2({
                        func: IMAGE_TYPE.MODEL,
                        type: 'background',
                        image: url,
                        attr: {
                            title: `${name}`,
                        }
                    })
                    if (res2?.code != 0) throw new Error(res2?.message)
                    props.onClick({ ...res2.data, attr: { ...res2.data?.attr, custom: true } })
                    if (res2?.data?.name) selectedKeys.push(res2.data.name)
                } else if (props.projectType == BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH) {
                    const res2 = await API.saveCustomMaterialv2({
                        func: IMAGE_TYPE.COMMODITY,
                        type: 'stacking',
                        image: url,
                        attr: {
                            title: `${name}`,
                        }
                    })
                    if (res2?.code != 0) throw new Error(res2?.message)
                    props.onClick({ ...res2.data, attr: { ...res2.data?.attr, custom: true } })
                    if (res2?.data?.name) selectedKeys.push(res2.data.name)
                } else {
                    const res2 = await API.saveCustomTryOnModel({
                        tryOnImage: url,
                        thumbnail: url,
                        imageAntispamId,
                        title: `${name}`,
                        async: 1
                    })
                    if (res2?.code != 0) throw new Error(res2?.message)
                    props.onClick({ ...res2.data, attr: { ...res2.data?.attr, custom: true } })
                    if (res2?.data?.name) selectedKeys.push(res2.data.name)
                }
                setSuccNum(pre => pre + 1)
            } catch (err) {
                console.error(err)
            }
            updateForce({})
        }
        setLoading(false)
        return selectedKeys
    }

    const uploadDebounce = useCallback(_.debounce((file, fileList) => {
        doUploadFiles(fileList)
    }, 100), [props.projectType])
    const beforeUpload = async (file, fileList) => {
        uploadDebounce(file, fileList)
        return false
    }
    const handleDrop = async (e) => {
        e.stopPropagation()
        if ("getFilesAndDirectories" in e.dataTransfer) {
            const filesAndDirs = await e.dataTransfer.getFilesAndDirectories()
            const fileList = await Utils.getFilesFromDirs(filesAndDirs, "/")
            console.log('===handleDrop===')
            uploadDebounce(fileList[0], fileList)
            return false
        }
    }
    const handleRemove = (record) => {
        PSAIModal.confirm({
            title: `确定删除这张自定义姿势？`,
            onOk() {
                return commonApiInvoker(API.removeCustomResources({
                    resourceIds: [record.id]
                })).then(() => {
                    message.success('删除成功')
                    updateForce({})
                    if (props.value.find(item => item.key == record.name)) props.onClick(record)
                })
            },
            onCancel() { },
        })
    }
    const handleFavor = (record) => {
        const data = getResourceData(props.projectType)
        if (record.isFavorite) {
            commonApiInvoker(API.unfavoriteResource({
                ...data,
                resourceId: [record.id]
            })).then(res => {
                message.success("已取消收藏")
                setList(pre => {
                    const temp = [...pre]
                    const item = temp.find(item => item.id == record.id)
                    item.isFavorite = false
                    return [...temp]
                })
            })
        } else {
            commonApiInvoker(API.favoriteResource({
                ...data,
                resourceId: record.id,
                custom: true,
            })).then(res => {
                message.success("已收藏")
                setList(pre => {
                    const temp = [...pre]
                    const item = temp.find(item => item.id == record.id)
                    item.isFavorite = true
                    return [...temp]
                })
            })
        }
    }

    const modelFormRef = useRef()
    const [open, setOpen] = useState(false)
    const handleNewModel = () => {
        // 需要登录
        const status = Utils.checkLoginStatus(() => handleNewModel())
        if (!status) return

        setOpen(true)
    }
    const handelOk = async () => {
        try {
            setLoading(true)
            const res = await modelFormRef.current.onSubmit()
            if (res) {
                message.success('模特添加成功')
                pendingAutoSelectIdRef.current = res
                setOpen(false)
                updateForce({})
            }
        } catch (err) {
            message.warning(err.message)
        } finally {
            setLoading(false)
        }
    }

    const uploadRequireResourceType = useMemo(() => {
        if (props.projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH) return RESOURCE_TYPE.MODEL
        if (props.projectType == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH) return RESOURCE_TYPE.MODEL_SCENE
        return RESOURCE_TYPE.TRYON_MODEL
    }, [props.projectType])

    const showUploadRequire = useMemo(() => {
        return uploadRequireResourceType != RESOURCE_TYPE.TRYON_SHOES &&
            uploadRequireResourceType != RESOURCE_TYPE.MODEL_SCENE &&
            uploadRequireResourceType != RESOURCE_TYPE.COMMODITY_SCENE &&
            uploadRequireResourceType != RESOURCE_TYPE.TRYON_SCENE &&
            uploadRequireResourceType != RESOURCE_TYPE.GLASSES_TRYON
    }, [uploadRequireResourceType])

    return (
        <>
            <div className={`_beauty_scrollbar`} style={{ ...props.style, paddingRight: 4 }}>
                <div className={styles.SelectTryonPose}>
                    {
                        props.projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ?
                            <div className={styles.UploadTriggerBatch} onClick={handleNewModel}>
                                <div className={styles.UploadContentBatch}>
                                    {loading ? <LoadingOutlined /> : <PlusOutlined />}
                                    <div className={styles.UploadContentExtra}>新增模特</div>
                                    {showUploadRequire &&
                                        <Popover
                                            trigger="hover"
                                            placement="bottomLeft"
                                            arrow={false}
                                            content={<UploadRequirements resourceType={uploadRequireResourceType} />}
                                            onClick={e => e.stopPropagation()}
                                        >
                                            <span className={styles.RequireTrigger}>图片要求</span>
                                        </Popover>}
                                </div>
                            </div> :
                            <Upload.Dragger
                                multiple
                                accept='image/jpeg,image/png,image/webp,image/avif'
                                listType="picture-card"
                                showUploadList={false}
                                className={styles.UploadWrapBatch}
                                beforeUpload={beforeUpload}
                                onDrop={handleDrop}
                                disabled={loading}
                            >
                                <div className={styles.UploadContentBatch}>
                                    {loading ? <LoadingOutlined /> : <PlusOutlined />}
                                    <div className={styles.UploadContentExtra}>
                                        <span style={{ fontSize: 14, display: "block", color: "#5B6673", whiteSpace: "nowrap", marginBottom: 5 }}>{loading ? `已上传 ${succNum}/${totalNum}` : "点击上传"}</span>
                                        <span style={{ fontSize: 14, display: "block", color: "#5B6673", whiteSpace: "nowrap" }}>最多30张/次</span>
                                    </div>
                                    {showUploadRequire &&
                                        <Popover
                                            trigger="hover"
                                            placement="bottomLeft"
                                            arrow={false}
                                            content={<UploadRequirements resourceType={uploadRequireResourceType} />}
                                            onClick={e => e.stopPropagation()}
                                        >
                                            <span className={styles.RequireTrigger}>图片要求</span>
                                        </Popover>}
                                </div>
                            </Upload.Dragger>
                    }
                </div>
                {
                    list.map(item => (
                        <ImageItem
                            key={item.id}
                            hideCustomIcon
                            projectType={props.projectType}
                            toolGroup={
                                item.attr?.maskStatus == "failed" ? {
                                    onRemove: () => handleRemove(item)
                                } : {
                                    onFavor: () => handleFavor(item),
                                    onPreview: true,
                                    onRemove: () => handleRemove(item),
                                }
                            }
                            disabled={!("maskStatus" in item.attr ? item.attr?.maskStatus == "succeeded" : true)}
                            record={item}
                            selectList={props.value}
                            maxCount={props.maxCount}
                            onClick={props.onClick}
                        />
                    ))
                }
            </div>
            <PSAIModal
                getContainer={document.body}
                title="新增模特"
                maxWidth={586}
                open={open}
                confirmLoading={loading}
                onOk={handelOk}
                onCancel={() => setOpen(false)}
            >
                <CustomModelForm ref={modelFormRef} />
            </PSAIModal>
        </>
    )
})

const FavoritePoseList = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        refresh: () => updateForce({})
    }))

    const [list, setList] = useState([])
    const [force, updateForce] = useState()
    useEffect(() => {
        if (props.activeKey != "favorite") return
        props.onChange(list)
    }, [props.activeKey, list])
    const totalRef = useRef(1)
    useEffect(() => {
        const params = {}
        const data = getResourceData(props.projectType)
        commonApiInvoker(API.getFavoriteResources({
            ...data,
            pageIndex: 1,
            pageSize: totalRef.current,
            ...params,
        })).then(res => {
            const total = res.total
            if (!total) return setList([])
            if (total != totalRef.current) {
                totalRef.current = total
                commonApiInvoker(API.getFavoriteResources({
                    ...data,
                    pageIndex: 1,
                    pageSize: totalRef.current,
                    ...params,
                })).then(res => {
                    const list = (res?.items ?? []).filter(item => item.name != "00_default_style")
                    setList(
                        list
                            .map(item => ({ ...item, isFavorite: true }))
                            .map(item => ({
                                ...item,
                                attr: {
                                    ...item.attr,
                                    custom: "custom" in item.attr ? item.attr.custom : item.attr.skin == "custom"
                                }
                            }))
                    )
                })
            } else {
                const list = (res?.items ?? []).filter(item => item.name != "00_default_style")
                setList(
                    list
                        .map(item => ({ ...item, isFavorite: true }))
                        .map(item => ({
                            ...item,
                            attr: {
                                ...item.attr,
                                custom: "custom" in item.attr ? item.attr.custom : item.attr.skin == "custom"
                            }
                        }))
                )
            }
        })
    }, [force])
    const handleFavor = (record) => {
        const data = getResourceData(props.projectType)
        if (record.isFavorite) {
            commonApiInvoker(API.unfavoriteResource({
                ...data,
                resourceId: [record.id]
            })).then(res => {
                message.success("已取消收藏")
                updateForce({})
                props.onFavor(record, false)
            })
        } else {
            commonApiInvoker(API.favoriteResource({
                ...data,
                resourceId: record.id,
                custom: !!record?.attr?.custom,
            })).then(res => {
                message.success("已收藏")
                updateForce({})
                props.onFavor(record, true)
            })
        }
    }
    const handleRemove = (record) => {
        PSAIModal.confirm({
            title: `确定删除这张自定义${props.projectType == BATCH_IMAGES_TYPE.TRYON_BATCH ? "试衣" : props.projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ? "模特" : "姿势"}？`,
            onOk() {
                return commonApiInvoker(API.removeCustomResources({
                    resourceIds: [record.id]
                })).then(() => {
                    message.success('删除成功')
                    updateForce({})
                    if (props.value.find(item => item.key == record.name)) props.onClick(record)
                })
            },
            onCancel() { },
        })
    }
    return (
        <>
            <div className={`_beauty_scrollbar`} style={{ ...props.style, paddingRight: 4 }}>
                {
                    list.map(item => (
                        <ImageItem
                            key={item.id}
                            projectType={props.projectType}
                            toolGroup={{
                                onPreview: true,
                                onFavor: () => handleFavor(item),
                                onRemove: () => handleRemove(item)
                            }}
                            record={item}
                            selectList={props.value}
                            maxCount={props.maxCount}
                            onClick={props.onClick}
                        />
                    ))
                }
            </div>
        </>
    )
})

const PoseList = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        refresh: () => updateForce({}),
        onFavor: (record, favor) => {
            setList(pre => {
                const temp = [...pre]
                const item = temp.find(item => item.id == record.id)
                if (!item) return temp
                item.isFavorite = favor
                return [...temp]
            })
        }
    }))
    const totalRef = useRef(1)
    const [force, updateForce] = useState()
    const [list, setList] = useState([])

    useEffect(() => {
        if (props.activeKey != "default") return
        props.onChange(list)
    }, [props.activeKey, list])

    useEffect(() => {
        if (props.activeKey != "default") return
        const params = {}
        const { sex, skin, age, shoesType, pose, clothesCate, toneTags, text, sceneTags, compositionTags } = props.filter
        if (age?.length > 0) params.age = age?.join()
        if (sex?.length > 0) params.sex = sex?.join()
        if (skin?.length > 0) params.skin = skin?.join()
        if (toneTags?.length > 0) params.toneTags = toneTags?.join()
        if (shoesType?.length > 0) params.shoesType = shoesType?.join()
        if (pose?.length > 0) params.poseType = pose?.join()
        if (clothesCate?.length > 0) params.clothesCate = clothesCate?.join()
        if (text?.length > 0) params.text = text
        if (sceneTags?.length > 0) params.sceneTags = sceneTags?.join()
        if (compositionTags?.length > 0) params.compositionTags = compositionTags?.join()
        const data = getResourceData(props.projectType)
        commonApiInvoker(API.getPresetResources2({
            ...data,
            ...params,
            pageIndex: 1,
            pageSize: totalRef.current
        })).then(res => {
            const total = res.total
            if (!total) return setList([])
            if (total != totalRef.current) {
                totalRef.current = total
                commonApiInvoker(API.getPresetResources2({
                    ...data,
                    ...params,
                    pageIndex: 1,
                    pageSize: totalRef.current
                })).then(res => {
                    const list = (res?.items ?? []).filter(item => (!item.name.includes("_random") && !item.name.includes("_keep") && !item.name.includes("_default_style")))
                    setList(list.map(item => ({
                        ...item,
                        isFavorite: item.attr.isFavorite,
                        attr: {
                            ...item.attr,
                            custom: false
                        }
                    })))
                })
            } else {
                const list = (res?.items ?? []).filter(item => (!item.name.includes("_random") && !item.name.includes("_keep") && !item.name.includes("_default_style")))
                setList(list.map(item => ({
                    ...item,
                    isFavorite: item.attr.isFavorite,
                    attr: {
                        ...item.attr,
                        custom: false
                    }
                })))
            }
        })
    }, [force, props.filter, props.activeKey])
    const handleFavor = (record) => {
        const data = getResourceData(props.projectType)
        if (record.isFavorite) {
            commonApiInvoker(API.unfavoriteResource({
                ...data,
                resourceId: [record.id]
            })).then(res => {
                message.success("已取消收藏")
                setList(pre => {
                    const temp = [...pre]
                    const item = temp.find(item => item.id == record.id)
                    item.isFavorite = false
                    return [...temp]
                })
            })
        } else {
            commonApiInvoker(API.favoriteResource({
                ...data,
                resourceId: record.id,
                custom: false,
            })).then(res => {
                message.success("已收藏")
                setList(pre => {
                    const temp = [...pre]
                    const item = temp.find(item => item.id == record.id)
                    item.isFavorite = true
                    return [...temp]
                })
            })
        }
    }
    return (
        <>
            <div className={`_beauty_scrollbar`} style={{ ...props.style, paddingRight: 4 }}>
                {
                    list.map(item => (
                        <ImageItem
                            key={item.id}
                            projectType={props.projectType}
                            toolGroup={{
                                onPreview: true,
                                onFavor: () => handleFavor(item),
                            }}
                            record={item}
                            selectList={props.value}
                            maxCount={props.maxCount}
                            onClick={props.onClick}
                        />
                    ))
                }
            </div>
        </>
    )
})

// 选择tryon姿势
const SelectTryonPose = forwardRef((props, ref) => {
    // props.readOnly
    // props.value
    // props.projectType
    const { drawOpen } = props
    const [value, setValue] = useState(Array.isArray(props.value) ? [...props.value] : [])
    const valueRef = useRef(value)
    useEffect(() => {
        valueRef.current = value
    }, [value])
    const [activeKey, setActiveKey] = useState(props.projectType == BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? "custom" : "default")
    const [filter, setFilter] = useState({
        skin: [], // 肤色
        sex: [], // 性别
        age: [], // 年龄
        toneTags: [], // 气质类型
        shoesType: [], // 品类 
        pose: [], // 姿势
        clothesCate: [], // 服饰品类
        text: "", // 搜索
        sceneTags: [], // 背景类别
        compositionTags: [], // 构图
    })
    const handleFilterChange = (filter) => {
        setFilter(pre => ({ ...pre, ...filter }))
    }

    const handleTabChange = (key) => {
        setActiveKey(key)
        setFilter(pre => ({ ...pre, text: "" }))
    }

    const handleClick = useCallback((record) => {
        if (props.readOnly) return
        setValue(pre => {
            if (pre.find(item => item.key == record.name)) {
                return pre.filter(item => item.key != record.name)
            }
            const item = { key: record.name }
            item.url = record.attr?.custom ? (record.attr.tryOnImage || record.imageUrl) : record.imageUrl
            item.custom = record.attr?.custom ? 1 : 0 // 0-预设 1-自定义
            item.colorMask = record.attr?.custom ? record.attr.colorMask : null
            item.title = record.attr?.title ? record.attr.title : null
            if (props.projectType == BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH) {
                item.num = 1
            }
            return [...pre, item].slice(props.maxCount == -1 ? 0 : -props.maxCount)
        })
    }, [props.readOnly, props.projectType, props.maxCount])

    const style = {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        alignContent: "flex-start",
        maxHeight: `calc(100vh - 180px)`,
        minHeight: `calc(100vh - 180px)`,
        gap: "10px"
    }

    const [displayList, setDisplayList] = useState([])
    const [prompt, setPrompt] = useState(typeof props.value === 'string' ? props.value : '')
    const handleChange = (list) => {
        setDisplayList(list)
    }

    useEffect(() => {
        if (props.projectType == BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH) {
            setPrompt(typeof props.value === 'string' ? props.value : '')
        }
    }, [props.projectType, props.value, drawOpen])

    const handleOk = () => {
        if (props.projectType == BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH) {
            props.onChange(prompt)
            props.onClose()
            return
        }
        props.onChange([...valueRef.current])
        props.onClose()
    }

    const handleUsePrompt = () => {
        const nextPrompt = (prompt || '').trim()
        if (props.onApplyImageToVideoPrompt) {
            props.onApplyImageToVideoPrompt(nextPrompt)
        } else {
            props.onChange(nextPrompt)
        }
        props.onClose()
    }

    const customRef = useRef()
    const defaultRef = useRef()
    const favorRef = useRef()

    useImperativeHandle(ref, () => ({
        refresh: () => {
            customRef.current?.refresh?.()
            defaultRef.current?.refresh?.()
            favorRef.current?.refresh?.()
        },
        uploadAndConfirm: async (fileList) => {
            if (!fileList?.length) return
            setActiveKey("custom")
            await new Promise(r => setTimeout(r, 0))
            const selectedKeys = await customRef.current?.uploadFiles?.(fileList)
            const lastKey = selectedKeys?.[selectedKeys.length - 1]
            if (lastKey) {
                const startAt = Date.now()
                while (Date.now() - startAt < 2000) {
                    if (valueRef.current.find(item => item.key == lastKey)) break
                    await new Promise(r => setTimeout(r, 16))
                }
            }
            props.onChange([...valueRef.current])
            props.onClose?.()
        }
    }))

    const handleDeleteBatch = () => {
        const displayRecords = []
        for (let item of value) {
            const displayItem = displayList.find(item2 => item2.name == item.key)
            if (!displayItem) continue
            displayRecords.push(displayItem)
        }
        const deleteRecords = displayRecords.filter(item => item.attr?.custom)
        if (deleteRecords.length == 0) return message.warning("当前页的预设姿势不可删除")
        const title = displayRecords.length == deleteRecords.length ?
            `确定删除当前页选中的 ${deleteRecords.length} 张自定义姿势？` :
            "确定要删除吗？"
        const content = displayRecords.length == deleteRecords.length ? "" :
            <span style={{ whiteSpace: "pre-wrap" }}>{`预设姿势不可删除，仅可删除当前页选中的 ${deleteRecords.length} 张自定义姿势。`}</span>
        PSAIModal.confirm({
            title: title,
            content: content,
            onOk() {
                return commonApiInvoker(API.removeCustomResources({ resourceIds: deleteRecords.map(item => item.id) })).then(() => {
                    message.success('删除成功')
                    const otherList = value.filter(item => !deleteRecords.find(item2 => item2.name == item.key))
                    setValue([...otherList])
                    activeKey == "custom" ?
                        customRef.current?.refresh() :
                        favorRef.current?.refresh()
                })
            },
            onCancel() { },
        })
    }
    const handleUnfavorBatch = () => {
        const displayRecords = []
        for (let item of value) {
            const displayItem = displayList.find(item2 => item2.name == item.key)
            if (!displayItem) continue
            displayRecords.push(displayItem)
        }
        const favorRecords = displayRecords.filter(item => item.isFavorite)
        if (favorRecords.length == 0) return message.warning("当前页没有选择已收藏的姿势")
        const data = getResourceData(props.projectType)
        const resourceList = favorRecords.map(item => item.id)
        commonApiInvoker(API.unfavoriteResource({
            ...data,
            resourceId: resourceList,
        })).then(res => {
            message.success("已取消收藏")
            if (activeKey == "custom") customRef.current?.refresh()
            else if (activeKey == "default") defaultRef.current?.refresh()
            else {
                defaultRef.current?.refresh()
                favorRef.current?.refresh()
            }
        })
    }

    const handleFavor = (record, faovr) => {
        defaultRef.current?.onFavor(record, faovr)
    }

    const handleRemove = ({ key }) => {
        setValue(value.filter(item => item.key != key))
    }

    // 背景筛选
    const [modelSceneTypeOpts, setModelSceneTypeOpts] = useState([])
    const [modelCompositionTypeOpts, setModelCompositionTypeOpts] = useState([])
    useEffect(() => {
        if (props.projectType != BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH) return
        Promise.all([
            API.categoryList({
                func: 'background',
                category: 'sceneTags',
                resourceType: 'model',
            }),
            API.categoryList({
                func: 'background',
                category: 'compositionTags',
                resourceType: 'model',
            })
        ]).then(([res1, res2]) => {
            const modelSceneTypeOpts = res1.data.map((item) => {
                return {
                    label: item.display,
                    title: item.display,
                    options: item.subList.map(opt => ({
                        label: opt.display,
                        value: item.display + '/' + opt.value,
                    })),
                }
            })
            const modelCompositionTypeOpts = res2.data
            setModelSceneTypeOpts(modelSceneTypeOpts || [])
            setModelCompositionTypeOpts(modelCompositionTypeOpts || [])
        })
    }, [])

    const sceneType = (
        <div className={styles.sceneTypeWrap}>
            <Select
                placeholder="构图"
                mode="multiple"
                allowClear={true}
                size="small"
                maxTagCount='responsive'
                style={{ width: 140, height: 32, marginRight: '12px' }}
                onChange={(value) => handleFilterChange({ compositionTags: value })}
                options={modelCompositionTypeOpts}
            />
            <Select
                placeholder="背景类型"
                mode="multiple"
                allowClear={true}
                size="small"
                maxTagCount='responsive'
                style={{ width: 140, height: 32, marginRight: '12px' }}
                onChange={(value) => handleFilterChange({ sceneTags: value })}
                options={modelSceneTypeOpts}
            />
            <SelectionFilterSearch onChange={value => handleFilterChange({ text: value })} />
        </div>

    )
    const operations = (
        <div className={styles.OperationsBatch}>
            {
                activeKey == "default" &&
                <div className={styles.operationsWrap}>
                    {
                        props.projectType == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ?
                            sceneType :
                            props.projectType == BATCH_IMAGES_TYPE.TRYON_BATCH || props.projectType == BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ?
                                <ModelFilterSelection filterValue={filter} imageType={IMAGE_TYPE.CLOTHES} isPose onChange={handleFilterChange} /> :
                                <ModelFilterSelectionNew filterValue={filter} imageType={IMAGE_TYPE.CLOTHES} onChange={handleFilterChange} />
                    }
                </div>
            }
            {/* <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
                <Button style={{ lineHeight: 1 }} disabled={value.length == 0} size="small" onClick={handleUnfavorBatch}>取消收藏</Button>
                {
                    activeKey != "default" &&
                    <Button style={{ lineHeight: 1 }} disabled={value.length == 0} size="small" onClick={handleDeleteBatch}>删除</Button>
                }
            </div> */}
        </div>
    )

    const selectedListRender = useMemo(() => (
        <div className={styles.SelectedListBatch}>
            {
                value.map(item => {
                    return (
                        <div key={item.key} className={styles.SelectedItem}>
                            <Image src={Utils.getImgThumbnail(item.url)} fallback={fallback} preview={false} />
                            <Iconfont onClick={() => handleRemove(item)} className={styles.Icon} type="icon-DeleteOutlined" />
                        </div>
                    )
                })
            }
        </div>
    ), [value])

    const title = useMemo(() => {
        return props.projectType == BATCH_IMAGES_TYPE.TRYON_BATCH ? "姿势" :
            props.projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ? "模特" :
                props.projectType == BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ? "模特" :
                    props.projectType == BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? "辅品" :
                        props.projectType == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ? "背景" : ""

    }, [props.projectType])

    const imageToVideoItems = [{
        key: 'prompt',
        label: `预设词库`,
        children: <ImgToVideoContent type='prompt' resourceType={RESOURCE_TYPE.IMAGE_TO_VIDEO} setPrompt={setPrompt} />,
        destroyOnHidden: true
    }, {
        key: 'mine',
        label: `我的模板`,
        children: <ImgToVideoContent type='mine' resourceType={RESOURCE_TYPE.IMAGE_TO_VIDEO} setPrompt={setPrompt} />,
        destroyOnHidden: true
    }]

    const items = [{
        key: "default",
        label: `预设${title}`,
        children: (
            <PoseList
                maxCount={props.maxCount}
                ref={defaultRef}
                projectType={props.projectType}
                activeKey={activeKey}
                value={value}
                style={style}
                onClick={handleClick}
                onChange={handleChange}
                filter={filter}
            />
        ),
    }, {
        key: "custom",
        label: `自定义${title}`,
        children: (
            <CustomPoseList
                ref={customRef}
                maxCount={props.maxCount}
                projectType={props.projectType}
                activeKey={activeKey}
                value={value}
                style={style}
                onClick={handleClick}
                onChange={handleChange}
            />
        ),
        destroyOnHidden: true
    }, {
        key: "favorite",
        label: "我的收藏",
        children: (
            <FavoritePoseList
                maxCount={props.maxCount}
                ref={favorRef} 
                projectType={props.projectType}
                activeKey={activeKey}
                value={value}
                style={style}
                onClick={handleClick}
                onChange={handleChange}
                onFavor={handleFavor}
            />
        ),
        destroyOnHidden: true
    }]

    return (
        <>
            <div className={styles.SelectTryonPoseWrap}>
                <CloseOutlined className={styles.CloseIcon} onClick={() => props.setDrawOpen(false)} />
                <div className={styles.PoseLeft}>
                    {
                        props.projectType == BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH ?
                            <div className={styles.ImgToVideoWrap}>
                                <Tabs
                                    size="small"
                                    defaultActiveKey="prompt"
                                    items={imageToVideoItems}
                                    className={styles.ImgToVideoTabs}
                                />
                                <div className={styles.ImgToVideoResultWrap}>
                                    <div className={styles.ImgToVideoResultTitle}>组合结果</div>
                                    <div className={styles.ImgToVideoResultInputWrap}>
                                        <Input.TextArea
                                            value={prompt}
                                            onChange={(e) => setPrompt(e.target.value)}
                                            placeholder="请从预设词库中选择词汇进行组合"
                                            maxLength={800}
                                            className={styles.ImgToVideoResultInput}
                                        />
                                        <div className={styles.ImgToVideoResultActions}>
                                            <Button className={styles.ImgToVideoResultClear} onClick={() => setPrompt('')}>
                                                <Iconfont type="icon-DeleteOutlined" />
                                            </Button>
                                            <Button type="primary" className={styles.ImgToVideoResultUse} onClick={handleUsePrompt}>
                                                使用描述
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            <Tabs
                                size="small"
                                activeKey={activeKey}
                                tabBarExtraContent={operations}
                                items={props.projectType == BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? items.filter(item => item.key != "default") : items}
                                onChange={handleTabChange}
                            />
                    }
                </div>
                {
                    props.projectType != BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH && props.maxCount > 1 &&
                    <div className={`${styles.PoseRight} _beauty_scrollbar`}>
                        <p style={{ marginBottom: 20 }}>已选参考图 {value.length}/{props.maxCount}</p>
                        {selectedListRender}
                    </div>
                }
            </div>

            {
                props.projectType != BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH &&
                <div className={styles.FooterBatch}>
                    <Button style={{ width: 200, height: 36, marginRight: 12 }} onClick={() => props.setDrawOpen(false)}>取消</Button>
                    <Button style={{ width: 200, height: 36 }} type="primary" onClick={handleOk}>确定</Button>
                </div>
            }
        </>

    )
})

export default SelectTryonPose